// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import moment from 'moment';
import VueMask from 'v-mask';
import LogRocket from 'logrocket';
import Logger from 'vuejs-logger';

import VeeValidator, {
	Validator
} from 'vee-validate';
import VeeValidatorDictionary from './support/validator/dictionary';
import CNPJValidator from './support/validator/cnpj.validator';
import CPFValidator from './support/validator/cpf.validator';
import VueCurrencyFilter from 'vue-currency-filter';

import GetText from 'vue-gettext';
import translations from './i18n/translations.json';
import lang from 'element-ui/lib/locale/lang/pt-br';
import locale from 'element-ui/lib/locale';
import {
	VueMasonryPlugin
} from 'vue-masonry';

import App from './App';
import router from './router';
import store from './store';
import filters from './filters';

//------------------------------------------------------------------------------

if (process.env.NODE_ENV === 'production' && process.env.LOG_ROCKET_ID) {
	LogRocket.init(process.env.LOG_ROCKET_ID);
}

Vue.use(VueMasonryPlugin);

Vue.use(VueCurrencyFilter, {
	symbol: 'R$',
	thousandsSeparator: '.',
	fractionCount: 2,
	fractionSeparator: ',',
	symbolPosition: 'front',
	symbolSpacing: true
});

locale.use(lang);
moment.locale('pt_BR');

Vue.use(VueMask);

Vue.use(Logger, {
	logLevel: 'debug',
	showLogLevel: true
});

Vue.use(VeeValidator, {
	locale: 'pt_BR',
	dictionary: VeeValidatorDictionary
});

Validator.extend('cnpj', CNPJValidator);
Validator.extend('cpf', CPFValidator);

Vue.use(GetText, {
	availableLanguages: {
		'pt_BR': 'Português',
		'en_US': 'English'
	},
	defaultLanguage: 'pt_BR',
	silent: true,
	translations
});

Vue.config.productionTip = true;

Vue.filter('enum', filters.storeENUM);
Vue.filter('now', filters.now);
Vue.filter('date', filters.date);
Vue.filter('truncate', filters.truncate);
Vue.filter('size', filters.size);
Vue.filter('capitalize', filters.capitalize);
Vue.filter('linebreak', filters.linebreak);
Vue.filter('ucwords', filters.ucwords);
Vue.filter('currency', filters.currency);

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	template: '<App/>',
	components: {
		App
	}
});



// WEBPACK FOOTER //
// ./sources/main.js